<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso a essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form >
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3 mb-5" *ngIf="planoContaEmpresa && !loading">
						<div class="col-12 card-simple">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-6 xl:col-1">
									<label class="label-superior">Código</label>
									<label class="label-inferior">{{ planoContaEmpresa.codigo }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Descrição da Conta</label>
									<label class="label-inferior">{{ planoContaEmpresa.descricao }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Especificação</label>
									<label class="label-inferior">{{ planoContaEmpresa.especificacao }}</label>
								</div>
		
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">DRE</label>
									<label class="label-inferior">{{ planoContaEmpresa.dre }}</label>
								</div>
		
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Grupo</label>
									<label class="label-inferior">{{ planoContaEmpresa.planoContaGrupo?.descricao }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Utilização</label>
									<label class="label-inferior">{{ planoContaEmpresa.utilizacao }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Referência Folha</label>
									<label class="label-inferior">{{ planoContaEmpresa.referenciaFolha }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Patrimonial</label>
									<label class="label-inferior">{{ planoContaEmpresa.patrimonial }}</label>
								</div>
								
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Configurável</label>
									<label class="label-inferior">{{ planoContaEmpresa.configuravel === true ? 'SIM' : 'NÃO' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Status</label>
									<label class="label-inferior">{{ planoContaEmpresa.ativo ? 'ATIVO' : 'INATIVO' }}</label>
								</div>

							</div>

						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/plano-conta-empresa"></button>
						</div>
					</div>
				</div>
			</form>

		</div>
	</div>
</div>